import React from "react";
import ImageSlider from "../components/ImageSlider";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { loadImages } from "../actions";

const frontload = async (props) => {
  await props.loadImages({ sliderType: "user" });
};
const mapStateToProps = (state) => {
  return {
    images: state.slider.user,
  };
};
const mapDispatchToProps = (dispatch) => ({
  loadImages: (...args) => dispatch(loadImages(...args)),
});

const sliderConfig = { arrows: false };

const UserImageSlider = ({ className = "", images }) => {
  return (
    <ImageSlider
      className={`user-image-slider ${className}`}
      images={images}
      sliderConfig={sliderConfig}
    />
  );
};

// export default UserImageSlider;
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(UserImageSlider),
);
